import { defineMessages } from '@jutro/locale';

export default defineMessages({
    correctSignatureButton: {
        id: 'adac.labels.components.SignDocumentComponent.Correct the signature',
        defaultMessage: 'Correct the signature'
    },
    signedDocumentInfo: {
        id: 'adac.labels.components.SignDocumentComponent.The signed document will be sent to the email',
        defaultMessage: 'The signed document will be sent to the email address provided in the claim application.'
    },
    sendButton: {
        id: 'adac.labels.components.SignDocumentComponent.Send',
        defaultMessage: 'Send'
    },
});
